export default __webpack_public_path__ + "static/media/hover-imatge-acompanyant@2x.ccbfb514.jpg";